import {
  Card,
  Box,
  Button,
  TextField,
  Breadcrumbs,
  Stack,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import React, { useEffect, useState } from "react";

import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Appbar from "../../components/Appbar";
import { Helmet } from "react-helmet-async";
import Body from "../../layout/Body";
import { useLocation } from "react-router-dom";
import TrackChangesSharpIcon from "@mui/icons-material/TrackChangesSharp";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Link } from "react-router-dom";
import { use } from "react";
import { getSinglePartnerAction } from "../../redux/toolkit/partner/singlePartner";
import moment from "moment";
import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { dateFormatStartFun } from "../../helper/dateConverter";
import { getSinglePublisherAction } from "../../redux/toolkit/publisher/publisherDetails";

import { dateWisePartnerRevenueAction } from "../../redux/toolkit/partner/dateWisePartnerRevenue";
import { publisherRevenueDetailsAction } from "../../redux/toolkit/publisher/publisherRevenueDetails";
import { singlePUblisherAction } from "../../redux/toolkit/publisher/singlePublisher";
import { publisherMonthlyStatsAction } from "../../redux/toolkit/publisher/publisherMonthlyStats";
import LoadingUI from "../../comman/LoadingUI";

const breadcrumb = (
  <Stack>
    <Breadcrumbs
      separator={
        <NavigateNextIcon sx={{ color: "#5E6C8A" }} fontSize="small" />
      }
      aria-label="breadcrumb"
    >
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/"
      >
        Home
      </Link>
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/partner"
      >
        Publiser
      </Link>
    </Breadcrumbs>
    <Typography sx={{ color: "#5E6C8A" }} variant="h4">
      Publisher Data
    </Typography>
  </Stack>
);

const PublisherRevenueDetails = () => {
  const searchParams = new URLSearchParams(useLocation()?.search);
  const publisherId = searchParams.get("publisher_id");

  let dispatch = useDispatch();
  const { data } = useSelector((state) => state.singlePublisher);
  // const getSinglePubliser = useSelector(state => state.getSinglePubliser)

  const { data: publisherRevenue } = useSelector(
    (state) => state.publisherRevenueDetails
  );

  const { data: monthlyStats, loading: monthlyStatsLoading } = useSelector(
    (state) => state.publisherMonthlyStats
  );

  const [date, setDate] = useState({
    startDate: null,
    endDate: null,
  });

  const dateWiseUser = () => {
    dispatch(
      publisherRevenueDetailsAction({
        publisherId: publisherId,
        startDate: dateFormatStartFun(date?.startDate),
        endDate: dateFormatStartFun(date?.endDate),
      })
    );
  };

  useEffect(() => {
    if (publisherId) {
      dispatch(singlePUblisherAction({ publisherId: publisherId }));
      dispatch(publisherMonthlyStatsAction({ publisher_id: publisherId }));
    }
  }, [dispatch, publisherId]);

  return (
    <>
      <Helmet>
        <title> Real Opinion Admin | Singel Publisher</title>
      </Helmet>
      <Appbar breadcrumb={breadcrumb} />
      <Body>
        <Stack spacing={2} direction={"row"} justifyContent={"space-between"}>
          <Typography variant="h6">Publisher Details</Typography>
        </Stack>

        <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Min Data"
              value={date?.startDate}
              maxDate={moment()}
              onChange={(newValue) => {
                setDate({ ...date, startDate: newValue });
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Max Data"
              value={date?.endDate}
              minDate={date?.startDate}
              maxDate={moment()}
              onChange={(newValue) => {
                setDate({ ...date, endDate: newValue });
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
          {date?.startDate && date?.endDate && (
            <Button variant="contained" onClick={dateWiseUser}>
              find data
            </Button>
          )}
        </Stack>

        <Card sx={{ p: 2, color: "#0C6A96" }}>
          <Stack direction="row" justifyContent="space-between">
            <TrackChangesSharpIcon color="#0C6A96" />
            <Typography
              sx={{
                color: "#5E6C8A",
                fontFamily: "Montserrat,sans-serif",
                fontStyle: "normal",
              }}
              variant="subtitle2"
            >
              Publisher Revenuer Details
            </Typography>
            {/* <IconButton sx={{ color: '#5E6C8A' }} onClick={handleRefeash}><CachedIcon /></IconButton> */}
          </Stack>

          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Box direction="row">
                <Typography
                  variant="h10"
                  color="primary"
                  sx={{ fontWeight: 600, color: "#071D45" }}
                >
                  Name :{" "}
                </Typography>
                <Typography
                  variant="h10"
                  color="primary"
                  sx={{ fontWeight: 600, color: "#071D45" }}
                >
                  {data[0]?.name}
                </Typography>
              </Box>

              <Box direction="row">
                <Typography
                  variant="h10"
                  color="primary"
                  sx={{ fontWeight: 600, color: "#071D45" }}
                >
                  {" "}
                  Email :{" "}
                </Typography>
                <Typography
                  variant="h10"
                  color="primary"
                  sx={{ fontWeight: 600, color: "#071D45" }}
                >
                  {data[0]?.email}
                </Typography>
              </Box>

              <Box direction="row">
                <Typography
                  variant="h10"
                  color="primary"
                  sx={{ fontWeight: 600, color: "#071D45" }}
                >
                  {" "}
                  total_earned_amount :{" "}
                </Typography>
                <Typography
                  variant="h10"
                  color="primary"
                  sx={{ fontWeight: 600, color: "#071D45" }}
                >
                  {data[0]?.total_earned_amount}
                </Typography>
              </Box>

              <Box direction="row">
                <Typography
                  variant="h10"
                  color="primary"
                  sx={{ fontWeight: 600, color: "#071D45" }}
                >
                  total_user_earned_amount :{" "}
                </Typography>
                <Typography
                  variant="h10"
                  color="primary"
                  sx={{ fontWeight: 600, color: "#071D45" }}
                >
                  {data[0]?.total_user_earned_amount}
                </Typography>
              </Box>
              <Box direction="row">
                <Typography
                  variant="h10"
                  color="primary"
                  sx={{ fontWeight: 600, color: "#071D45" }}
                >
                  is_verified :{" "}
                </Typography>
                <Typography
                  variant="h10"
                  color="primary"
                  sx={{ fontWeight: 600, color: "#071D45" }}
                >
                  {data[0]?.is_verified ? "true" : "false"}
                </Typography>
              </Box>

              {publisherRevenue && (
                <>
                  <Box direction="row">
                    <Typography
                      variant="h10"
                      color="primary"
                      sx={{ fontWeight: 600, color: "#071D45" }}
                    >
                      {" "}
                      DateWise Total Publiser Payout :{" "}
                    </Typography>
                    <Typography
                      variant="h10"
                      color="primary"
                      sx={{ fontWeight: 600, color: "#071D45" }}
                    >
                      {publisherRevenue?.totalAmount
                        ? Number(publisherRevenue.totalAmount).toFixed(4)
                        : "---"}
                    </Typography>
                  </Box>

                  <Box direction="row">
                    <Typography
                      variant="h10"
                      color="primary"
                      sx={{ fontWeight: 600, color: "#071D45" }}
                    >
                      {" "}
                      DateWise totalUser :{" "}
                    </Typography>
                    <Typography
                      variant="h10"
                      color="primary"
                      sx={{ fontWeight: 600, color: "#071D45" }}
                    >
                      {publisherRevenue?.totalUser
                        ? Number(publisherRevenue?.totalUser).toFixed(4)
                        : "---"}
                    </Typography>
                  </Box>

                  <Box direction="row">
                    <Typography
                      variant="h10"
                      color="primary"
                      sx={{ fontWeight: 600, color: "#071D45" }}
                    >
                      {" "}
                      DateWise No Of Widthdraw Transactionn :{" "}
                    </Typography>
                    <Typography
                      variant="h10"
                      color="primary"
                      sx={{ fontWeight: 600, color: "#071D45" }}
                    >
                      {publisherRevenue?.transactionCount
                        ? Number(publisherRevenue?.transactionCount).toFixed(4)
                        : "---"}
                    </Typography>
                  </Box>

                  <Box direction="row">
                    <Typography
                      variant="h10"
                      color="primary"
                      sx={{ fontWeight: 600, color: "#071D45" }}
                    >
                      {" "}
                      DateWise totalCompleted :{" "}
                    </Typography>
                    <Typography
                      variant="h10"
                      color="primary"
                      sx={{ fontWeight: 600, color: "#071D45" }}
                    >
                      {publisherRevenue?.totalCompleted
                        ? Number(publisherRevenue?.totalCompleted).toFixed(4)
                        : "---"}
                    </Typography>
                  </Box>

                  <Box direction="row">
                    <Typography
                      variant="h10"
                      color="primary" 
                      sx={{ fontWeight: 600, color: "#071D45" }}
                    >
                      {" "}
                      DateWise totalAttempted :{" "}
                    </Typography>
                    <Typography
                      variant="h10"
                      color="primary"
                      sx={{ fontWeight: 600, color: "#071D45" }}
                    >
                      {publisherRevenue?.totalAttempted
                        ? Number(publisherRevenue?.totalAttempted).toFixed(4)
                        : "---"}
                    </Typography>
                  </Box>


                  <Box direction="row">
                    <Typography
                      variant="h10"
                      color="primary"
                      sx={{ fontWeight: 600, color: "#071D45" }}
                    >
                      {" "}
                      DateWise coversionRate :{" "}
                    </Typography>
                    <Typography
                      variant="h10"
                      color="primary"
                      sx={{ fontWeight: 600, color: "#071D45" }}
                    >
                      {publisherRevenue?.conversionRate
                        ? Number(publisherRevenue?.conversionRate).toFixed(4)
                        : "---"}
                    </Typography>
                  </Box>


                  <Box direction="row">
                    <Typography
                      variant="h10"
                      color="primary"
                      sx={{ fontWeight: 600, color: "#071D45" }}
                    >
                      {" "}
                      DateWise averageRevenuePerUser :{" "}
                    </Typography>
                    <Typography
                      variant="h10"
                      color="primary"
                      sx={{ fontWeight: 600, color: "#071D45" }}
                    >
                      {publisherRevenue?.averageRevenuePerUser
                        ? Number(publisherRevenue?.averageRevenuePerUser).toFixed(4)
                        : "---"}
                    </Typography>
                  </Box>
                </>
              )}
            </Grid>
          </Grid>
        </Card>

        {/* Monthly Stats Section */}
        <Card sx={{ mt: 3, p: 2 }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Last 12 Months Earnings & Chargebacks
          </Typography>

          {monthlyStatsLoading ? (
            <LoadingUI />
          ) : monthlyStats && monthlyStats.length > 0 ? (
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow sx={{ bgcolor: "#071D45" }}>
                    <TableCell sx={{ color: "#fff", fontWeight: 600 }}>
                      Month
                    </TableCell>
                    <TableCell sx={{ color: "#fff", fontWeight: 600 }}>
                      Year
                    </TableCell>
                    <TableCell
                      sx={{ color: "#fff", fontWeight: 600 }}
                      align="right"
                    >
                      Earnings
                    </TableCell>
                    <TableCell
                      sx={{ color: "#fff", fontWeight: 600 }}
                      align="right"
                    >
                      Chargebacks
                    </TableCell>
                    <TableCell
                      sx={{ color: "#fff", fontWeight: 600 }}
                      align="right"
                    >
                      Net Amount
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {monthlyStats.map((stat, index) => {
                    const netAmount = stat.earnings + stat.chargeback;
                    const monthName = moment()
                      .month(stat.month - 1)
                      .format("MMMM");
                    return (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                          bgcolor: index % 2 === 0 ? "#f5f5f5" : "white",
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {monthName}
                        </TableCell>
                        <TableCell>{stat.year}</TableCell>
                        <TableCell align="right" sx={{ color: "green" }}>
                          {stat.earnings
                            ? Number(stat.earnings).toFixed(4)
                            : "0.0000"}
                        </TableCell>
                        <TableCell align="right" sx={{ color: "red" }}>
                          {stat.chargeback
                            ? Number(stat.chargeback).toFixed(4)
                            : "0.0000"}
                        </TableCell>
                        <TableCell
                          align="right"
                          sx={{
                            color: netAmount >= 0 ? "green" : "red",
                            fontWeight: 600,
                          }}
                        >
                          {Number(netAmount).toFixed(4)}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Typography>No monthly data available</Typography>
          )}
        </Card>
      </Body>
    </>
  );
};

export default PublisherRevenueDetails;
